import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Data = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M5.2 10C5.2 10.8837 4.48366 11.6 3.6 11.6C2.71635 11.6 2 10.8837 2 10C2 9.11634 2.71635 8.4 3.6 8.4C4.48366 8.4 5.2 9.11634 5.2 10ZM5.2 10H14.8M14.8 10C14.8 10.8837 15.5163 11.6 16.4 11.6C17.2837 11.6 18 10.8837 18 10C18 9.11634 17.2837 8.4 16.4 8.4C15.5163 8.4 14.8 9.11634 14.8 10ZM14.8 3.6C14.8 4.48366 15.5163 5.2 16.4 5.2C17.2837 5.2 18 4.48366 18 3.6C18 2.71635 17.2837 2 16.4 2C15.5163 2 14.8 2.71635 14.8 3.6ZM14.8 3.6H10.2C9.75817 3.6 9.4 3.95817 9.4 4.4V15.6C9.4 16.0418 9.75817 16.4 10.2 16.4H14.8M14.8 16.4C14.8 17.2837 15.5163 18 16.4 18C17.2837 18 18 17.2837 18 16.4C18 15.5163 17.2837 14.8 16.4 14.8C15.5163 14.8 14.8 15.5163 14.8 16.4Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
})

export default Data
